export const API_URL = import.meta.env.VITE_API_URL || 'https://api.satutim.id/api/v1';
export const MAIN_APP_URL = import.meta.env.VITE_MAIN_APP_URL || 'https://satutim.id';
export const VAPID_PUBLIC_KEY_FALLBACK = import.meta.env.VITE_VAPID_PUBLIC_KEY || '';
